import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {createRoot} from 'react-dom/client';
import './index.css';
// import 'boostrap/dist/css/bootsrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


const rootElement = document.getElementById('root');

createRoot(rootElement).render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
